const DEFAULT_POSITIONS = ['center', 'center 20%', 'center 80%'];

export default function VerticalCarousel({ images, duration = 28, positions = DEFAULT_POSITIONS }) {
    const slides = [...images, ...images];

    return (
        <div className="vertical-carousel" aria-hidden="true">
            <div
                className="vertical-carousel-track"
                style={{ '--carousel-duration': `${duration}s` }}
            >
                {slides.map((src, index) => (
                    <div key={index} className="vertical-carousel-slide">
                        <img
                            src={src}
                            alt=""
                            style={{ objectPosition: positions[index % positions.length] }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
